import { SessionCalendarType as i } from "@waitroom/models";
const f = (e) => `${e.sessionID}-${e.sessionRecurrenceID}`, c = (e) => !!e.calendarID && e.calendarType === i.Google, d = (e, n) => {
  if (e.length === 1 || !n) return e;
  let t = e[0];
  const a = e.filter((r) => r.id !== n ? !0 : (t = r, !1));
  return [t, ...a];
}, o = (e, n) => {
  var t;
  return !n || !e || !n.team ? !1 : n.id === e.id ? !0 : n.team.id === ((t = e == null ? void 0 : e.team) == null ? void 0 : t.id);
};
export {
  c as hasGoogleCalendarIntegration,
  o as isOnSameTeamWithPrimaryHost,
  f as sessionIdsKey,
  d as sortHosts
};
